import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { FORM_CACHE_SNAPSHOT_HEADER } from '#/api/system/formCache/constants';
import {
  buildWorkOrderStockTransferCreatePayload,
} from '#/api/momMgmt/workOrder/transfer/serializeTransferWrite';

/**
 * 工單彙總轉倉 create（`mom.work_order.stock_transfer.create`）。
 * POST `/mom/work-order/stock-transfer`
 * 勿傳 `sourceType`／`sourceId`（後端固定 WORK_ORDER／null）。
 *
 * Cache-aware Create 可選帶 `X-Form-Cache-Snapshot-Id`（僅正式建立且 snapshot 對應 exact ACTIVE 草稿時）。
 *
 * @param {object} values
 * @param {{ formCacheSnapshotId?: string | null }} [options]
 */
export async function createWorkOrderStockTransfer(values, options = {}) {
  const snapshotId = options.formCacheSnapshotId;
  const config = {};
  if (snapshotId) {
    config.headers = {
      [FORM_CACHE_SNAPSHOT_HEADER]: snapshotId,
    };
  }

  const { data: raw } = await request.post(
    '/mom/work-order/stock-transfer',
    keysToSnake(buildWorkOrderStockTransferCreatePayload(values)),
    config,
  );
  return parseVer4DetailResponse(raw);
}
